import { Card, Text, TextLink } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import type { CustomerRole } from '../../customers/types/role';
import type { CustomerMinimal } from '../types/company';
import { DetailRow } from './detail-row';

export function CompanyUserCard({
  customer,
  role,
}: {
  customer: CustomerMinimal;
  role?: CustomerRole;
}) {
  const { navigationHandler } = useHandlers();
  return (
    <Card variant="secondary" key={customer.id}>
      <Card.Header
        headingLevel="h5"
        primaryAction={{
          onClick: () =>
            navigationHandler.navigate(`/v2/customers/list/details/${customer.id}`, {
              newTab: true,
            }),
          variant: 'bare',
          icon: 'externalLink',
        }}
      >
        {`${customer.first_name || ''} ${customer.last_name || ''}`.trim() ||
          customer.email || // Do I need to worry about Japan etc where first and last name are swapped?
          customer.id}
      </Card.Header>
      <Card.Body>
        <DetailRow
          label={t('features:sections.components.section_list.company_users.email')}
          value={customer.email}
        />
        {role && (
          <div className="flex gap-2">
            <Text>{t('features:sections.components.section_list.company_users.role')}</Text>
            <TextLink
              variant="primary"
              size="sm"
              onClick={() => navigationHandler.navigate(`v2/customers/roles/edit/${role.slug}`)}
            >
              {role.name}
            </TextLink>
            <Text variant="secondary">
              <em>({role.slug})</em>
            </Text>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
